// extracted by mini-css-extract-plugin
export default {"page":"RW-z","cartModal":"SW-z","checkout":"TW-z","placeholder":"UW-z","account":"VW-z"};